import React from 'react';

const WidgetPrev = (props) => {
  const preText = props.state.prevMessage;
  const _prev = () => {
    props.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.actionProvider._home(-1);
  };
  return (
    <div className="prev-chat-container">
      <div className="prev-contaner">
        {preText === '' || preText === undefined || preText === null ? null : (
          <div onClick={_prev} className="prev">
            <img src="/img/chatbot/icon_prev.png" />
            이전 단계로 이동
          </div>
        )}

        <div onClick={_goHome} className="prev">
          <img src="/img/chatbot/icon_home.png" />
          처음으로
        </div>
      </div>
    </div>
  );
};

export default WidgetPrev;
